module.exports = __webpack_public_path__ + "static/media/settings.a979f4b0.svg";